import * as React from 'react';
import S from './Badge.styles';
const Badge = ({ className, color, text }) => {
    return (React.createElement(S.Container, { className: className, backgroundColor: color ? color : '#FFE8D8', style: { '--bgColor': color } }, text));
};
export default Badge;
